import React, { useState,useEffect,Component } from 'react'
import './Home.css';
import InputHome from './InputHome';
import validate from './validateInfo';
import MaterialTable from 'material-table';
import ajax from '../utility/ajax';
import { trackPromise } from 'react-promise-tracker';
import { usePromiseTracker } from 'react-promise-tracker';
import Select from "react-select"
import plandata from './data.json'



function App() {
  
  const [mo2fproduct, setProduct] = useState(null);
  const [lang, setLang] = useState(null);
  const [mo2fplan, setPlan] = useState([]); 
  const [id, setId] = useState([])
  const [data, setData] = useState([])
  const [xyz,setXyz] = useState(null)
  const [custom_val, setcustome_val] = useState('')
  const [is_custom, setiscustom] = useState(false)
  const [planObj, setplanObj] = useState(null)
  const columns = [
        { title: "Username", field: "username" },
        { title: "payment_plan", field: "payment_plan" },
        { title: "Description", field:"description" },
        { title: "Payment_timestamp", field:"payment_timestamp" },
        { title: "Amount", field:"amount" },
        { title: "Net_amount", field:"net_amount" },
        { title: "Quote_number", field:"quote_number" },
    ]
  
    const { promiseInProgress } = usePromiseTracker();
  
    async function callAPI(planname,sdate,edate) {  
             
             var startDate = new Date(sdate);
             var endDate   = new Date(edate);
             if (startDate.getTime() < endDate.getTime())
               {}
             else if (startDate.getTime() > endDate.getTime())
                alert("Start date is greater than end date");
             else
                alert("Dates are equal");
              setId(id);
              const axiosApp = await ajax();
              const data = {'planname': planname,'sdate':sdate,'edate':edate }
            trackPromise(
              axiosApp.post('/api_service/payment_resource', data, { headers: { Authorization: "Bearer " +   localStorage.getItem('idToken') } }).then(response => {
                 
                if (response.data.data.payment.length === 0)
                      alert("No result");
                  if (response.data.error !== undefined)
                      alert(response.data.error)
                  else
                      setData(response.data.data.payment)
              }).catch(e => {
                  alert("Failed: " + e.response.statusText)
              })
             );
      
          }
    function mo2f_plan_product_show(x){
      var y = document.getElementById("mo2f_product_and_plan");
      
      if (x.style.display === "block") {
        setiscustom(false)
        x.style.display = "none";
        y.style.display = "block";
      } else {
        setiscustom(true)
        x.style.display = "block";
        y.style.display = "none";
      }
    }

    function moluGetRevenue(){
      var temp = is_custom?custom_val:xyz
   
      callAPI(temp,document.getElementById("mo_plan_start_date").value,document.getElementById("mo_plan_ending_date").value)
    }
      
          const [searchTerm, setSearchTerm] = useState('');
          const { handleChange, values, handleSubmit, errors } = InputHome(validate);
          const [show, setShow] = useState(false);
      
 
  // handle change event of the product dropdown
  const handleProductChange = (obj) => {
    setProduct(obj);
    setPlan(obj.plan);
    setplanObj(null);
    setLang(obj.plan);
  };

  
 
  // handle change event of the plan dropdown
  const handlePlanChange = (obj) => {
    setplanObj(obj);
    setXyz(obj.name);  
  };
  
  return (
    <div className="App" >
       <link
                rel="stylesheet"
                href="https://fonts.googleapis.com/icon?family=Material+Icons"
                
            />
          <br/>
         <form className='form' onSubmit={handleSubmit}>
             <div className = 'mo2f_maindiv' style={{ width: 400, marginBottom: 20}}>
             <input type="checkbox" id="mo2f_search_one_plan" name="mo2f_search_one_plan" onChange={()=> mo2f_plan_product_show(document.getElementById("mo2f_only_plan"))} />
             &nbsp;&nbsp;Please click here If your plan is not listed in the dropdown list.
             <br/> 
               <br/>
               <div id="mo2f_product_and_plan">
                  <b>Product</b>
                  <Select
                    placeholder="Select Product"
                    value={mo2fproduct}
                    options={plandata}
                    onChange={handleProductChange}
                    getOptionLabel={x => x.product}
                    
                  />
                  <br />
                  <b>Plan</b>
                  <Select
                    placeholder="Select Plan"
                    id="miniorange_plan_name"
                    value={planObj}
                    options={lang}
                    onChange={handlePlanChange}
                    getOptionLabel={x => x.name}
                  
                  />
                </div> 
                  <br/>

                 <div className="ui input focus mo2f_hide" id="mo2f_only_plan">
                  <b>Plan name: </b> 
                 <input className = 'mo2f_input_style' type="text" placeholder="Search..." value={custom_val} onChange={(e)=>setcustome_val(e.target.value)}/>
                  </div>
                  <br/>
                  <b>Start:- </b>
                  
                  <input type="date" id="mo_plan_start_date" placeholder="yyyy-mm-dd" name="mo_plan_start_date" size="30" ></input>
                 
                  <b>   End:- </b>
                  
                  <input type="date" id="mo_plan_ending_date" placeholder="yyyy-mm-dd" name="mo_plan_ending_date"></input>
                  <br/>
                  <button className='searchBtn' type='submit' onClick={moluGetRevenue} >Get Result</button>
           
              </div>

                    <hr className='hrcss' />
                            <div className="CustomerTable">{!promiseInProgress && 
                                  <MaterialTable
                                      title="Customer List"
                                        data={data}
                                        columns={columns}
                                        options={{
                                            headerStyle: { position: 'sticky', top: 0 ,zIndex:0},
                                            search: false,
                                            paging: false,
                                            filtering: true
                                        }}
                                    />
                                }    
                             </div>

          </form>
      
    </div>
  );
}
 
export default App;

